import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreMaterialModule } from '@nttp/core-material';
import { DashboardComponent } from '@pg-app/partner/dashboard/containers/dashboard.component';
import { RoleGuard } from '@pg-app/core/services/roles/role.guard';
import { RoleNames } from '@pg-app/core/services/roles/RoleNames';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRole: RoleNames.VIEW_DASHBOARD,
      redirectUrl: '/partner/referral'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), CommonModule, CoreMaterialModule],
  declarations: []
})
export class DashboardRoutingModule { }
